import React from 'react';
import { spacing } from '@material-ui/system';
import styled from 'styled-components';
import { Box as MuiBox, BoxProps } from '@material-ui/core';

export const Box = styled(MuiBox)<BoxProps>`
  ${spacing}
`;
